import { render } from "./DoughnutChart1.vue?vue&type=template&id=32301a31&scoped=true"
import script from "./DoughnutChart1.vue?vue&type=script&lang=js"
export * from "./DoughnutChart1.vue?vue&type=script&lang=js"

import "./DoughnutChart1.vue?vue&type=style&index=0&id=32301a31&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32301a31"]])

export default __exports__